require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./keyword-boilerplate.json") })
        }
      }, "path---keyword-boilerplate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---keyword-boilerplate!./.cache/json/keyword-boilerplate.json
// module id = 689
// module chunks = 231608221292675